import { useMemo } from 'react';
import { StringParam, withDefault } from 'use-query-params';
import { usePageParams } from '../../../hooks/usePageParams';

export type CollectionsPageParams = {
  customerID: string;
};

export function useCollectionsPageParams() {
  const config = useMemo(
    () => ({
      customerID: withDefault(StringParam, ''),
    }),
    []
  );

  return usePageParams<CollectionsPageParams>(config);
}
